import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ProductCategory, ManufacturingOperation, ProductionLine, SpecificManufacturingOperation } from '../../inspection/shared/models/Inspection';
import { InspectionService } from '../../inspection/shared/services/inspection.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../shared/services/alert.service';
import { ErisFormModalComponent } from '../../shared/components/eris-form-modal/eris-form-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-production-line-config',
  templateUrl: './production-line-config.component.html',
  styleUrls: ['./production-line-config.component.css']
})
export class ProductionLineConfigComponent implements OnInit {
  public selectedProductCategory: ProductCategory;
  public selectedManuOp: ManufacturingOperation;
  public selectedSpecificManuOp: SpecificManufacturingOperation;
  public productionLines : ProductionLine[] = [];
  public modalRef: BsModalRef;

  constructor(private inspectionService: InspectionService, private spinner: NgxSpinnerService,
    private alertService: AlertService, private modalService: BsModalService) { }

  ngOnInit(): void {
  }

  fetchProductionLines() {
    this.spinner.show();
    this.inspectionService.getProductionLines(this.selectedSpecificManuOp.id).subscribe(resp => {
      this.spinner.hide();
      this.productionLines = resp;
    }, error => {
      this.spinner.hide();
    })
  }

  submitNewProductionLine(data) {
    var productionLine = new ProductionLine();
    productionLine.name = data.name;
    productionLine.specificManufacturingOperationID = this.selectedSpecificManuOp.id;
    this.spinner.show();
    this.inspectionService.addProductionLine(productionLine).subscribe(resp => {
      this.spinner.hide();
      if(resp) {
        this.alertService.success("Successfuly created production line");
        this.fetchProductionLines();
      } else {
        this.alertService.error("Couldn't create production line, please try again");
      }
    }, error => {
      this.spinner.hide();
      this.alertService.error("Couldn't create production line, please try again");
    })
  }

  addNewProductionLineClicked() {
    const initialState = {
      title: 'Add Production Line',
      fields: this.addProductionLineFields
    };

    this.modalRef = this.modalService.show(ErisFormModalComponent, {initialState, class: 'modal-md'});
    this.modalRef.content.closeModal.subscribe(() => {
      this.modalRef.hide();
    });
    this.modalRef.content.submitForm.subscribe((data: any) => {
      this.submitNewProductionLine(data);
      this.modalRef.hide();
    });
  }

  activateDeactivateProductionLine(productionLineId : number) {
    this.inspectionService.activateDeactivateProductionLine(productionLineId).subscribe(resp => {
      var prodLine = this.productionLines.find(p => p.id == productionLineId);
      prodLine.isActive = !prodLine.isActive;
    })
  }

  listProductionLineFields = [
    {
      fieldGroup: [
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              key: 'productCategory',
              type: 'lookup',
              className: "col-md-4",
              templateOptions: {
                label: 'Product Category',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                responseFn: (res) => {
                  this.selectedProductCategory = res;
                  return ({
                    name: res.name,
                    id: res.id,
                  })
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory`,
                  responseFn: (res) => res,
                },
              },
            },
            {
              key: 'manufacturingOperation',
              type: 'lookup',
              className: "col-md-4",
              templateOptions: {
                label: 'Manufacturing Operation',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                dependsOnField: "productCategory",
                responseFn: (res: ManufacturingOperation) => {
                  this.selectedManuOp = res;
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetManufacturingOperations/${this.selectedProductCategory?.id}`,
                  responseFn: (res) => res,
                },
              },
            },
            {
              key: 'specificManufacturingOperation',
              type: 'lookup',
              className: "col-md-4",
              templateOptions: {
                label: 'Specific Manufacturing Operation',
                required: true,
                multiple: false,
                prefetch: true,
                searchable: false,
                minLengthTerm: 0,
                dependsOnField: "manufacturingOperation",
                responseFn: (res) => {
                  this.selectedSpecificManuOp = res;
                  return res;
                },
                list: {
                  method: "get",
                  url: (term) =>
                    `${environment.baseUrl}/ProductCategory/GetSpecificManufacturingOperations/${this.selectedManuOp?.id}`,
                  responseFn: (res) => res,
                },
              },
            }
          ]
        },
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              type: "submit",
              className: "col-md-offset-11 col-md-1",
              templateOptions: {
                label: "Fetch",
              },
            },
          ]
        },
      ]
    }
  ];

  addProductionLineFields = [
    {
      fieldGroup: [
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              key: "name",
              type: "input",
              className: "col-md-12",
              templateOptions: {
                label: "Production Line",
                required: true
              },
              validators: {
                validation: ["normal-text"],
              },
            },
          ]
        },
        {
          fieldGroupClassName: "row",
          fieldGroup : [
            {
              type: "submit",
              className: "col-md-offset-10 col-md-1",
              templateOptions: {
                label: "Submit",
              },
            },
          ]
        },
      ] 
    }
  ];
}
